import { AvailabilityDetails } from '../../types/monitoringUpdate'
import useStyles from './Styles/InputBoxValuesRoomTypeMenu.Style'
import TimeCell from './TimeCell'

interface InputBoxValuesRatePlaneMenuProps {
  range: 'TWO_WEEKS' | 'MONTH'
  index: number
  data: AvailabilityDetails
  weekendIndexes: number[]
}
export default function InputBoxValuesRatePlaneMenu({
  index,
  data,
  weekendIndexes,
  range
}: InputBoxValuesRatePlaneMenuProps) {
  const classes = useStyles()
  return (
    <div className={classes.status}>
      <div
        className={[
          classes.dayContainer,
          weekendIndexes.includes(index % 7) ? classes.weekendDayContainer : ''
        ].join(' ')}>
        <TimeCell dataStatus={data} range={range} />
      </div>
    </div>
  )
}
